import Vue from 'vue';
import Vuex from 'vuex';
import type { IAppState } from './constants';

// Store Modules
import { NAVIGATION_NAMESPACE, navigation } from './modules/navigation';
import { ACCOUNT_NAMESPACE, account } from './modules/account';
import { LOYALTY_NAMESPACE, loyalty } from './modules/loyalty';
import {
    RESPONSIBLE_GAMING_NAMESPACE,
    responsibleGaming,
} from './modules/responsible-gaming';
import { NAVIGATIONS_NAMESPACE, navigations } from './modules/navigations';

Vue.use(Vuex);

export const store = new Vuex.Store<IAppState>({
    strict: true,
    modules: {
        [NAVIGATION_NAMESPACE]: navigation,
        [ACCOUNT_NAMESPACE]: account,
        [RESPONSIBLE_GAMING_NAMESPACE]: responsibleGaming,
        [LOYALTY_NAMESPACE]: loyalty,
        [NAVIGATIONS_NAMESPACE]: navigations,
    },
    state: {},
});
